import React from "react";
import { ConfigureButton } from "components";
import _ from "lodash";
import moment, { Moment } from "moment";
import TimePicker from "rc-time-picker";
import "rc-time-picker/assets/index.css";
import { styled, theme, createGlobalStyle } from "styles";
import { View, Icon } from "ui";

interface P {
  title: string;
  time: moment.Moment;
  onChange?: (hour: moment.Moment) => void;
}

interface S {
  open: boolean;
  selectedTime: Moment;
}
class AlertHour extends React.Component<P, S> {
  public state = { open: false, selectedTime: this.props.time || moment() };
  public componentDidUpdate(prevProps) {
    if (prevProps.time !== this.props.time) {
      this.setState({ selectedTime: this.props.time });
    }
  }
  public componentDidMount(){
    window.document.body.addEventListener("click", this.handleModalClick);
  }
  public componentWillUnmount(){
    window.document.body.removeEventListener("click", this.handleModalClick);
    this.setState({ open: false });
  }
  public handleModalClick = (e: MouseEvent) => {
    if (!this.state.open){
      return;
    }
    const path = e.composedPath();
    const panelElement = _.find(path, (p: HTMLElement) => {
      if (!p || !p.classList){
        return false;
      }
      return p.classList.contains("rc-time-picker-panel");
    });
    if (!panelElement){
      this.setState({ open: false });
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
    }

  }
  public handleOpen = () => this.setState({ open: true });
  public handleClose = () => {
    this.setState({ open: false, selectedTime: this.props.time });
  }
  public handleConfirm = () => {
    this.setState({ open: false });
    this.props.onChange(this.state.selectedTime);
  }
  public handleChange = (selectedTime: Moment) => {
    this.setState({ selectedTime });
  }
  public render() {
    const { title, time } = this.props;
    const { open, selectedTime } = this.state;
    return (
      <React.Fragment>
        <ConfigureButton
          leftIcon="clock"
          title={title}
          rightIcon="list"
          rightText={`${time ? time.format("HH:mm") : ""}`}
          onClick={this.handleOpen}
        />
        <TimePickerModalStyles />
        <StyledTimePicker
          format="HH:mm"
          showSecond={false}
          minuteStep={15}
          value={selectedTime}
          open={open}
          onChange={this.handleChange}
          placement="bottomRight"
          popupClassName="time-popup"
          addon={() => (
            <View
              flexDirection="row"
              justifyContent="space-around"
              alignItems="center"
            >
              <TimePickerButton onClick={this.handleClose}>
                <Icon name="close" size={2} color={theme.colors.primary} />
              </TimePickerButton>
              <TimePickerButton onClick={this.handleConfirm}>
                <Icon name="check" size={2} color={theme.colors.primary} />
              </TimePickerButton>
            </View>
          )}
        />
      </React.Fragment>
    );
  }
}
export default AlertHour;

const TimePickerModalStyles = createGlobalStyle`
    .rc-time-picker-panel-combobox{
    display: flex;
  }
`;

const TimePickerButton = styled(View)`
  cursor: pointer;
`;
const StyledTimePicker = styled(TimePicker)`
  /* display: none!important; */
  .rc-time-picker-input {
    display: none;
  }
  .rc-time-picker-clear {
    display: none;
  }
`;

// public render(){
//   const { title, time, onChange } = this.props;
//   return (
//     <PopupState variant="popover" popupId="alert-hour">
//       {popupState => (
//         <React.Fragment>
//           <ConfigureButton
//             leftIcon="clock"
//             title={title}
//             rightIcon="list"
//             rightText={`${time ? time.format("HH:mm") : ""}`}
//             {...bindTrigger(popupState)}
//           />
//           <Menu
//             {...bindMenu(popupState)}
//             anchorOrigin={{
//               vertical: "bottom",
//               horizontal: "right"
//             }}
//             transformOrigin={{
//               vertical: "top",
//               horizontal: "right"
//             }}
//           >
//             {_.range(0, 24).map(h =>
//               _.range(0, 60, 15).map(m => {
//                 const hour = _.padStart(`${h}`, 2, "0");
//                 const minute = _.padStart(`${m}`, 2, "0");
//                 return (
//                   <MenuItem
//                     key={`${hour}:${minute}`}
//                     onClick={e => {
//                       popupState.close(e);
//                       if (onChange) {
//                         onChange(moment(`${hour}:${minute}`, "HH:mm"));
//                       }
//                     }}
//                   >
//                     {hour}:{minute}
//                   </MenuItem>
//                 );
//               })
//             )}
//           </Menu>
//         </React.Fragment>
//       )}
//     </PopupState>
//   );
// }



// WEBPACK FOOTER //
// ./src/routes/main/components/AlertHour.tsx